<template>
    <div>
        <b-row>
            <b-col md="5">
                <h3 class="header">
                    {{ $t('menu.projects') }}
                    <b-badge class="badge-small">{{ user_projects.length }}</b-badge>
                </h3>
            </b-col>
            <b-col md="3"></b-col>
            <b-col md="4">
                <SearchTool :list_data="projects" :search_key="[]" @search-result="search_result = $event">
                </SearchTool>
            </b-col>
        </b-row>



        <div>

            <b-row>

                <b-col cols="12" xl="6" v-if="search_result.length == 0">
                    <NoData></NoData>
                </b-col>
                <b-col cols="12" xl="6" v-for="(proj,idx) in search_result" :key="idx">
                    <b-card>
                        <b-media no-body>
                            <b-media-aside vertical-align="top">
                                <div class="proj-img cover-bg clickable-img" alt="project photo"
                                    @click="goToPage('project', proj.id)"
                                    :style="$tools.style.imgCover( $config.checkURL('pic', proj.pic) )" />

                            </b-media-aside>
                            <b-media-body class="ml-3">
                                <b-row>
                                    <b-col sm="8" md="8" lg="8">
                                        <h4 class="card-title agri-color clickable" v-text="proj.name"
                                            @click="goToPage('project', proj.id)"></h4>
                                    </b-col>
                                    <b-col sm="4" md="4" lg="4">
                                        <!-- 服務等級 -->
                                        <div :class="$tools.style.classServiceLevel(proj.service_level) + ' mb-2'">
                                            <i class="fa fa-shield"></i>
                                            {{ $t('status.service_level.' + proj.service_level ) }}
                                        </div>

                                    </b-col>
                                </b-row>

                                <!-- 時區 -->
                                <div class="card-subtitle mb-2">
                                    <i class="fa fa-clock-o block-text"></i>
                                    <div class="block-text">{{ $t('menu.timezone') }}:</div>
                                    <div class="block-text">{{ proj.timezone }}</div>
                                </div>
                                <!-- 開始日期 -->
                                <div class="card-subtitle mb-2">
                                    <i class="fa fa-calendar block-text"></i>
                                    <div class="block-text">{{ $t('menu.start_date') }}:</div>
                                    <div class="block-text">{{ proj.start_date }}</div>
                                    <div class="block-text">( {{ proj.count_projectDays + ' '  + $t('u.days') }} )</div>
                                </div>
                                <!-- 專案到期日期 -->
                                <div :class="'card-subtitle mb-2 ' + style_Expiry(proj)" v-if="proj.end_date">
                                    <i class="fa fa-quote-left block-text"></i>
                                    <div class="block-text">{{ $t('menu.expiry_date') }}:</div>
                                    <div class="block-text">{{ proj.end_date }}</div>
                                </div>
                                <!-- 地址 -->
                                <div class="card-subtitle mb-2">
                                    <i class="icon-location-pin block-text"></i>
                                    <div class="block-text">{{ $t('menu.location') }}:</div>
                                    <div class="block-text">{{ proj.location }}</div>
                                </div>

                                <!-- 頁面按鈕 -->
                                <div class="card-subtitle mb-2">
                                    <b-button class="btn btn-cp" :to="{ name: 'AgriDiary', params: { projectID: proj.id } }">
                                        <i class="fa fa-book"></i>{{ $t('menu.agridiary') }}
                                    </b-button>

                                    <b-button class="btn btn-cp" :to="{ name: 'Project History', params: { projectID: proj.id } }">
                                        <i class="fa fa-history"></i>{{ $t('menu.history') }}
                                    </b-button>

                                    <b-button v-if="check_ShowContent( proj.service_level, 'report')"
                                              class="btn btn-cp" :to="{ name: 'Reports', params: { projectID: proj.id } }">
                                        <i class="fa fa-line-chart"></i>{{ $t('menu.agri_science_reports') }}
                                    </b-button>

                                    <b-button v-if="proj.service_level == 'lite'"
                                              class="btn btn-cp" :to="{ name: 'Custom Alert Rule Management', params: { projectID: proj.id } }">
                                        <i class="fa fa-gear"></i>{{ $t('menu.custom_alert_rule_management') }}
                                    </b-button>
                                </div>

                            </b-media-body>
                        </b-media>

                        <div v-if="proj.editable">
                            <hr>
                            <h5 class="block-text">{{ $t('menu.management') }}</h5>
                            <div class="block-text">
                                <b-button class="btn btn-outline-secondary block-text" :to="{ name: 'Project Management', params: { projectID: proj.id } }">
                                    <i class="fa fa-gear"></i>{{ $t('menu.project_management') }}
                                </b-button>

                                <b-button class="btn btn-outline-secondary block-text" :to="{ name: 'Cropperiod Management', params: { projectID: proj.id } }">
                                    <i class="fa fa-gear"></i>{{ $t('menu.cropping_season_management') }}
                                </b-button>

                                <b-button class="btn btn-outline-secondary block-text" :to="{ name: 'Device Management', params: { projectID: proj.id } }">
                                    <i class="fa fa-gear"></i>{{ $t('menu.device_management') }}
                                </b-button>

                                <b-button class="btn btn-outline-secondary block-text" :to="{ name: 'Custom Alert Rule Management', params: { projectID: proj.id } }">
                                    <i class="fa fa-gear"></i>{{ $t('menu.custom_alert_rule_management') }}
                                </b-button>
                            </div>
                        </div>

                        <div v-if="check_ShowContent( proj.service_level, 'dashboard')">

                            <hr>

                            <h5 class="block-text">{{ $t('menu.agri_dashboard') }}</h5>
                            <div v-for="(cp, idx_cp) in proj.cropperiods" :key="idx_cp" class="cp-buttons">
                                <b-button class="btn-cp"
                                    :to="$config.getPagesURL('project', { projectID: proj.id, cropperiodID: cp.id })">
                                    <i class="fa fa-dashboard"></i>{{ cp.name }}
                                </b-button>

                                <!-- 逆境預警偵測 -->
                                <div class="stress-group">
                                    <StressAlertList :queryHours="6" :timezone="proj.timezone" :showType="'icon'"
                                        :project_id="proj.id" :cropperiod_id="cp.id" :linkToDashboard="true">
                                    </StressAlertList>
                                </div>
                            </div>
                        </div>

                    </b-card>
                </b-col>

            </b-row>
        </div><!-- Active Projects -- END -->



        <!-- Suspend Projects -->
        <div v-if="user_projects_suspend.length > 0">

            <hr>

            <b-row>
                <b-col md="5">
                    <h3 class="header">
                        {{ $t('menu.projects') }} ( {{ $t('menu.finished') }} )
                        <b-badge class="badge-small">{{ user_projects_suspend.length }}</b-badge>
                    </h3>
                </b-col>
                <b-col md="3"></b-col>
                <b-col md="4">
                    <SearchTool :list_data="user_projects_suspend" :search_key="[]"
                        @search-result="search_result_suspend = $event"></SearchTool>
                </b-col>
            </b-row>

            <b-row>

                <b-col cols="12" xl="6" v-if="search_result_suspend.length == 0">
                    <NoData></NoData>
                </b-col>
                <b-col cols="12" xl="6" v-for="(proj,idx) in search_result_suspend" :key="idx">
                    <b-card>
                        <b-media no-body>
                            <b-media-aside vertical-align="top">
                                <div class="proj-img cover-bg clickable-img" alt="project photo"
                                    @click="goToPage('project', proj.id)"
                                    :style="$tools.style.imgCover( $config.checkURL('pic', proj.pic) )" />
                                <!-- <div class="proj-img cover-bg clickable-img" alt="project photo"
                    :style="$tools.style.imgCover( $config.checkURL('pic', proj.pic) )" /> -->

                            </b-media-aside>
                            <b-media-body class="ml-3">
                                <b-row>
                                    <b-col sm="8" md="8" lg="8">
                                        <h4 class="card-title agri-color clickable" v-text="proj.name"
                                            @click="goToPage('project', proj.id)"></h4>
                                        <!-- <h4 class="card-title agri-color clickable" v-text="proj.name"></h4> -->
                                    </b-col>
                                    <b-col sm="4" md="4" lg="4">
                                        <!-- 服務等級 -->
                                        <div :class="$tools.style.classServiceLevel(proj.service_level) + ' mb-2'">
                                            <i class="fa fa-shield"></i>
                                            {{ $t('status.service_level.' + proj.service_level ) }}
                                        </div>

                                    </b-col>
                                </b-row>

                                <!-- 時區 -->
                                <div class="card-subtitle mb-2">
                                    <i class="fa fa-clock-o block-text"></i>
                                    <div class="block-text">{{ $t('menu.timezone') }}:</div>
                                    <div class="block-text">{{ proj.timezone }}</div>
                                </div>
                                <!-- 開始日期 -->
                                <div class="card-subtitle mb-2">
                                    <i class="fa fa-calendar block-text"></i>
                                    <div class="block-text">{{ $t('menu.start_date') }}:</div>
                                    <div class="block-text">
                                        {{ proj.start_date }}
                                        <template v-if="proj.end_date"> - {{ proj.end_date }}</template>
                                    </div>
                                    <div class="block-text">( {{ proj.count_projectDays + ' '  + $t('u.days') }} )</div>
                                </div>
                                <!-- 專案到期日期 -->
                                <div :class="'card-subtitle mb-2 ' + style_Expiry(proj)" v-if="proj.end_date">
                                    <i class="fa fa-quote-left block-text"></i>
                                    <div class="block-text">{{ $t('menu.expiry_date') }}:</div>
                                    <div class="block-text">{{ proj.end_date }}</div>
                                </div>
                                <!-- 地址 -->
                                <div class="card-subtitle mb-2">
                                    <i class="icon-location-pin block-text"></i>
                                    <div class="block-text">{{ $t('menu.location') }}:</div>
                                    <div class="block-text">{{ proj.location }}</div>
                                </div>

                            </b-media-body>
                        </b-media>

                        <b-button-group class="block-md">
                            <b-button variant="outline-success"
                                :to="$config.getPagesURL('history', { projectID: proj.id })">
                                {{ $t('menu.history') }}
                            </b-button>
                        </b-button-group>

                    </b-card>
                </b-col>

            </b-row>
        </div><!-- Suspend Projects -- END -->
    </div>
</template>

<script>
import { mapState } from 'vuex'
import NoData from '@/views/components/NoData'
import StressAlertList from '@/views/components/StressAlertList'
import SearchTool from '@/views/components/SearchTool'


export default {
    components: {
        NoData,
        StressAlertList,
        SearchTool,
    },
    data () {
        return {
            search_result: [],
            search_result_suspend: [],
            search_result_done: [],

            user_projects_suspend: [],
            user_projects_done: [],
        }
    },
    computed: {
        ...mapState({
            'user_projects': state => state.project.projects,
        }),

        projects() {
            return (this.user_projects ? this.user_projects : []);
        },
    },
    methods: {

        check_ShowContent (proj_level, item)
        {
            // if ( this.user_admin ) return true

            if ( proj_level == 'lite' )
            {
                switch (item)
                {
                    case 'report':      return false
                    case 'dashboard':   return false
                    case 'management':  return false
                    default: return true
                }
            }

            return true
        },

        style_Expiry (projInfo)
        {
            let _class = 'expiry-date'
            let _diff_days = this.$tools.date.countDays( projInfo.end_date, undefined, projInfo.timezone )
            if ( Math.abs( _diff_days ) <= 30 ) _class += '-due'
            return _class
        },

        goToPage: function (type, pID, cpID = undefined) {
            this.$router.push(this.$config.getPagesURL(type, {
                projectID: pID,
                cropperiodID: cpID
            }));
        },
    },
}
</script>

<style lang="scss" scoped>

.stress-group {
    padding: 0px;
    padding-right: 3px;
}

.cp-buttons {
    display: inline-block;
    padding: 3px 0px;
    margin-right: 5px;
    //border-bottom: 1px solid #dddddd;
}

</style>
